<template>
  <div class="bg-dim flex-col">
    <div class="safe-area absolute">
      <div class="popup-wrap">
        <div class="popup-textbox">
          <span style="white-space: pre-line">{{ message }}</span>
        </div>
      </div>
      <div class="button-wrap">
        <button class="button-bg-gray" @click="noEvent()">{{no}}</button>
        <button class="button-bg-yellow" @click="yesEvent()">{{yes}}</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CommonConfirmPopup",
  props: ['message', 'no', 'yes'],
  methods: {
    noEvent() { //no 버튼 눌렀을때 이벤트
      this.$emit('confirmPopupClickNo');
    },
    yesEvent() {    //yes 버튼 눌렀을때 이벤트
      this.$emit('confirmPopupClickYes');
    }
  }
};
</script>

<style lang="scss" scoped>
    @import '@/assets/styles/common/bottomButton.scss';

    .absolute { position: fixed; bottom: 0; width: 100%; }
    .popup-wrap {
      min-height: rem(66);
      border-radius: rem(24) rem(24) 0 0;
      background-color: $color-white;
    }
    .popup-textbox {
      padding: rem(36) rem(16) rem(41);
      text-align: center;
      span {
        display: block;
        @include font-size(rem(16), rem(22), 700);
        color: $color-black-400;
      }
    }
</style>